import * as _ from 'lodash';
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { loadEventConfig } from '../../../event/features/event.actions';
import { selectEventConfig } from '../../../event/features/event.selectors';

import { AuctionHelperService } from '../../../core/services/auction-helper.service';
import { filter, takeUntil } from 'rxjs/operators';
import { EventPageData } from 'app/event-page/models/event-page-data.model';
import { EventPageService } from 'app/event-page/services/event-page.service';
import { EventPageHeaderTypeService } from 'app/event-page/services/event-page-header-type.service';
import { Subject } from 'rxjs';
import { FacebookService } from 'app/facebook/providers/facebook';

@Component({
  selector: 'app-event-page',
  templateUrl: './event-page.component.html',
  styleUrls: ['./event-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class EventPageComponent implements OnInit, OnDestroy {

  public loadEventConfig$ = this.store.pipe(
    select(selectEventConfig)
  );

  public eventPageConfig = null;
  public eventPageData = null;
  public eventPageClasses = {};

  public takeUntilSubject = new Subject();

  constructor(
    public auctionHelperService: AuctionHelperService,
    private store: Store,
    private fb: FacebookService,
    public eventPageService: EventPageService,
    public eventPageHeaderTypeService: EventPageHeaderTypeService,
  ) { }

  ngOnInit(): void {
    const parts = window.location.pathname.split('/').filter(a => a !== '');
    const eventTypeObj = {
      'in-person-event': 0,
      'virtual-event': 1,
      'hybrid-event': 2
    }

    this.store.dispatch({
      type: loadEventConfig.type,
      payload: {
        eventType: eventTypeObj[parts[0]],
        orgHandle: parts[1],
        eventIntId: parseInt(parts[2])
      }
    });

    this.loadEventConfig$.pipe(
      takeUntil(this.takeUntilSubject),
      filter(eventPageConfig => !_.isNull(eventPageConfig))
    ).subscribe((eventPageConfig) => {
      this.eventPageConfig = eventPageConfig;
      this.eventPageData = new EventPageData(this.eventPageConfig);
      
      this.eventPageService.selectedTheme = this.eventPageService.themes[eventPageConfig.templateType];
      
      const eventPageThemeClass = `event-page__${this.eventPageService.selectedTheme}`;
      this.eventPageClasses = {
        [eventPageThemeClass]: true,
      }

      if (this.eventPageConfig.templateType === 10 && this.eventPageConfig.customColorTheme) {
        this.eventPageConfig.setThemeColors();
      }
    });
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }
}